import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {LocalCustomerModel} from '../../../models/LocalCustomerModel';
import {RegionModel} from '../../../models/RegionModel';
import {ResourcesUnitModel} from '../../../models/ResourcesUnitModel';
import { MatTableDataSource } from '@angular/material/table';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {ServiceChangesModel} from '../../../models/ServiceChangesModel';
import {ServiceChangesService} from '../service/service-changes.service';
import {ContractTypeModel} from '../../../models/ContractTypeModel';
import {ContractualDataModel} from '../../../models/ContractualDataModel';
import {ProviderModel} from '../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';

@Component({
  selector: 'app-new-service-changes',
  templateUrl: './new-service-changes.component.html',
  styleUrls: ['./new-service-changes.component.scss']
})
export class NewServiceChangesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  showContract: boolean;

  getPageSubscribe: Subscription;
  serviceChanges: ServiceChangesModel;
  contratto: ContractualDataModel;
  localCustomerSelect: LocalCustomerModel;
  regionSelect: RegionModel;
  resourceUnitSelect: ResourcesUnitModel;
  contractTypeSelect: ContractTypeModel;
  providerSelect: ProviderModel;
  contractualDataSelect: ContractualDataModel;
  saveContractualData: Subscription;
  allMonth: any;
  listData: MatTableDataSource<any>;

  registerForm: FormGroup;  submitted = false;



  constructor(private route: ActivatedRoute, private router: Router,
              private serviceChangesService: ServiceChangesService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.showContract = false;
    this.serviceChanges = new ServiceChangesModel();
    this.contratto = new ContractualDataModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.regionSelect = new RegionModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.providerSelect = new ProviderModel();
    this.contractualDataSelect = new ContractualDataModel();
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      month: [{value: '', disabled: false}, Validators.required],
      region: [{value: '', disabled: false}, Validators.required],
      localCustomer: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      resourceUnitName: [{value: '', disabled: false}, Validators.required],
      resourceUnitCod: [{value: '', disabled: false}, Validators.required],
      provider: [{value: '', disabled: false}, Validators.required],
      shareName: [{value: '', disabled: false}],
      applicationCod: [{value: '', disabled: false}],
      delta: [{value: '', disabled: false}, Validators.required],
    });
    this.getAllMonth();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SERVICE_CHANGES], {queryParams: {selectedIndex: 0}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.serviceChanges.numAnnoMese = this.registerForm.value.month;
      this.serviceChanges.shareName = this.registerForm.value.shareName;
      this.serviceChanges.applicationCod = this.registerForm.value.applicationCod;
      // sarà da togliere anche back end
      this.serviceChanges.delta = this.registerForm.value.delta;

      event.preventDefault();
      this.loaderService.display(true);
      this.saveContractualData = this.serviceChangesService.save(this.serviceChangesService.baseUrl, this.serviceChanges)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Service Change was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.SERVICE_CHANGES]);
            }
          },
          error => {
            toastr.error('Service Change was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }



  getAllMonth() {
    this.getPageSubscribe = this.annoMeseService.getAllMonth(this.providerSelect)
      .subscribe(
        (result: any) => {
          this.allMonth = result;
        });
  }

  ngOnDestroy(): void {
    if (this.saveContractualData) {
      this.saveContractualData.unsubscribe();
    }
  }

  getElementSelectedContract($event) {
    this.showContract = false;
    this.contractualDataSelect = $event.row;
    this.regionSelect = this.contractualDataSelect.region;
    this.localCustomerSelect = this.contractualDataSelect.localCustomer;
    this.resourceUnitSelect = this.contractualDataSelect.resourceUnit;
    this.contractTypeSelect = this.contractualDataSelect.contractType;
    this.providerSelect = this.contractualDataSelect.provider;

    this.serviceChanges.region = this.contractualDataSelect.region;
    this.serviceChanges.localCustomer = this.contractualDataSelect.localCustomer;
    this.serviceChanges.resourceUnit = this.contractualDataSelect.resourceUnit;
    this.serviceChanges.contractType = this.contractualDataSelect.contractType;
    this.serviceChanges.provider = this.contractualDataSelect.provider;

    this.registerForm.patchValue({
      month: this.contractualDataSelect.numAnnoMese
    });
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });

    this.registerForm.patchValue({
      localCustomer: this.localCustomerSelect.cod
    });

    this.registerForm.patchValue({
      contractType: this.contractTypeSelect.cod
    });

    this.registerForm.patchValue({
      resourceUnitCod: this.resourceUnitSelect.cod
    });

    this.registerForm.patchValue({
      resourceUnitName: this.resourceUnitSelect.name
    });

    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
  }

  handle(value) {
    this.serviceChanges.numAnnoMese = value;
    this.registerForm.patchValue({
      anno: value
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  toggleContract() {
    this.showContract = !this.showContract;
  }

}

